<template>
  <div id="login">
    <el-container class="page_login">
      <el-main>
        <div class="ForgetPass">
          <el-steps
            class="el__steps"
            :active="activeStep"
            process-status="wait"
          >
            <el-step title="验证用户"></el-step>
            <el-step title="回答问题"></el-step>
            <el-step title="重置密码"></el-step>
          </el-steps>
          <div class="el__setps_box">
            <div class="box_item">
              <el-form
                ref="checkuser"
                :model="checkuser"
                :rules="checkuserRules"
                v-if="activeStep === 1"
              >
                <el-form-item prop="roleType">
                  <el-select
                    v-model="checkuser.roleType"
                    placeholder="请选择您的身份"
                  >
                    <el-option
                      v-for="item in roleTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="account">
                  <el-input
                    v-model="checkuser.account"
                    placeholder="请输入用户名"
                  />
                </el-form-item>

                <el-form-item class="el__form__item">
                  <el-button
                    size="default"
                    type="primary"
                    class="el__button"
                    @click="submitCheckuserForm('checkuser')"
                    >下一步</el-button
                  >
                </el-form-item>
              </el-form>
              <el-form ref="wentiForm" v-if="activeStep === 2">
                <el-form-item
                  v-for="(item, index) in questionsData.userQuestionList"
                  :key="item.questionCode"
                  :label="`问题${index + 1}:${item.question}?`"
                >
                  <div slot="label" class="el__slot__label">
                    问题{{ index + 1 }}: <span>{{ item.question }}</span>
                  </div>
                  <el-input v-model="item.answer" placeholder="请输入答案">
                  </el-input>
                </el-form-item>

                <el-form-item class="el__form__item">
                  <el-button
                    size="default"
                    type="primary"
                    class="el__button"
                    @click="questionSubmit"
                    >下一步</el-button
                  >
                </el-form-item>
              </el-form>
              <el-form
                v-if="activeStep === 3"
                ref="questionsData"
                :model="questionsData"
              >
                <el-form-item
                  prop="password"
                  :rules="[
                    {
                      required: true,
                      message: '密码不能为空',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    placeholder="请输入新密码"
                    v-model="questionsData.password"
                    type="password"
                  >
                    <!-- <div slot="prefix" class="roletype_label">密码:</div> -->
                  </el-input>
                </el-form-item>
                <el-form-item
                  prop="password2"
                  :rules="[
                    {
                      validator: checkPassword,
                      required: true,
                      message: '密码不能为空',
                      trigger: 'blur',
                    },
                    {
                      min: 6,
                      message: '密码必须为6位以上',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    placeholder="确认新密码"
                    v-model="questionsData.password2"
                    type="password"
                  >
                    <!-- <div slot="prefix" class="roletype_label">确认密码:</div> -->
                  </el-input>
                </el-form-item>
                <el-form-item class="el__form__item">
                  <el-button
                    size="default"
                    type="primary"
                    class="el__button"
                    @click="passSubmit"
                    >确定</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </el-main>
      <el-footer>
        <foo-ter></foo-ter>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import fooTer from '../footer/footer'
import { forgetCheckuser, forgetModifyPassword } from '@/api/home'
export default {
  components: {
    fooTer,
  },
  data() {
    return {
      // 身份
      roleTypeList: [
        { label: '学校管理员', value: 'school' },
        { label: '教师', value: 'teacher' },
      ],
      // 当前步骤
      activeStep: 1,
      checkuser: {
        roleType: '',
        account: '',
      },
      checkuserRules: {
        roleType: [
          {
            required: true,
            message: '请选择您的身份',
            trigger: ['blur', 'change'],
          },
        ],
        account: [
          {
            validator: this.chaeckUser,
            required: true,
            message: '请输入用户名',
            trigger: 'blur',
          },
        ],
      },
      questionsData: {
        roleType: 'school',
        userId: '',
        userQuestionList: [
          {
            questionCode: '1',
            question: '你的生日是什么',
            answer: '',
          },
          {
            questionCode: '2',
            question: '你出生在那座城市',
            answer: '',
          },
        ],
        questionCode: '',
        password: '',
        password2: '',
      },
    }
  },
  created() {},
  methods: {
    checkPassword(rule, value, callback) {
      if (!value) {
        return callback(new Error('二次密码不能为空'))
      } else {
        if (this.questionsData.password2 !== this.questionsData.password) {
          return callback(new Error('两次密码必须输入一致'))
        } else {
          callback()
        }
      }
    },
    async chaeckUser(rule, value, callback) {
      if (!this.checkuser.roleType) {
        this.$message.error('请先选择用户身份')
        return callback(new Error('请先选择用户身份'))
      }
      if (!value) {
        return callback(new Error('用户名'))
      } else {
        const { data: res } = await forgetCheckuser({ ...this.checkuser })
        this.questionsData = res.data
      }
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    // 验证账号通过
    async submitCheckuserForm(formName) {
      this.$nextTick()
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.activeStep = 2
          this.resetForm(formName)
        } else {
          return false
        }
      })
    },
    // 密保验证、跳转第三步
    async questionSubmit() {
      const res = await forgetModifyPassword({
        roleType: this.questionsData.roleType,
        userId: this.questionsData.userId,
        useranswerList: this.questionsData.userQuestionList,
      })
      if (!res) {
        this.$refs.wentiForm.resetFields()
        return false
      }
      let answerList = this.questionsData.userQuestionList
      let flag = {
        valid: true,
        message: '',
      }
      answerList.map((k) => {
        if (k.answer == '') {
          flag = {
            valid: false,
            message: '密保问题{' + k.question + '}不能为空',
          }
        }
      })
      if (!flag.valid) {
        this.$message.error(flag.message)
      } else {
        this.activeStep = 3
      }
    },

    passSubmit() {
      this.$refs.questionsData.validate((valid) => {
        if (valid) {
          const { questionsData } = this
          delete questionsData.password2
          let data = {
            password: this.questionsData.password,
            roleType: this.questionsData.roleType,
            userId: this.questionsData.userId,
            useranswerList: this.questionsData.userQuestionList,
          }
          console.log('questionsData', questionsData)
          forgetModifyPassword({
            ...data,
          }).then((res) => {
            this.resetForm('questionsData')
            this.$message({
              message: '密码修改成功！！！',
              type: 'success',
            })
            setTimeout(() => {
              this.$router.replace('/')
            }, 500)
          })
        } else {
          return false
        }
      })
    },
  },
}
</script>
<style scoped>
#login {
  /* background-color: red; */
  height: 969px;
  width: 100%;
}
.page_login {
  background-color: #f0f2f5;
  width: 100%;
  height: 100vh;
}
.el-main {
  background-image: url('../../assets/img/login/bg_image.a7a1ba61.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  page-break-after: auto;
  position: relative;
}
.ForgetPass {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  width: 1000px;
  padding: 50px 40px;
  height: 490px;
  border-radius: 10px;
}
.el__steps {
  width: 600px;
  margin: 0 auto;
}
.el__setps_box {
  width: 400px;
  margin: 40px auto;
}
.box_item {
  margin-top: 40px;
}
.el-form {
  width: 100%;
}
.el__button,
.el-select,
.el-input {
  width: 100%;
}
.el__form__item {
  margin-top: 40px;
}
.el-input__inner {
  border: none;
  border-bottom: 1px solid #dcdfe6;
  text-align: center;
  border-radius: 0;
}
.el__slot__label {
  font-size: 16px;
}
.el__slot__label span {
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/views/login/forget.vue